<template>
  <div>
    <Grid
      :service="service"
      route_name="payment_orders"
      route_grid_path="/grid"
      order_column="created_at"
      direction="desc"
      :show-export="true"
      :export-types="['csv', 'xls']"
      export-filename="hubee_payment_orders"
      :fetch-on-mounted="false"
      hide_searchbar="true"
      ref="grid"
    >
      <template v-slot:filterZone>
        <FinancialPeriodFilter v-model="filters" @change="handleFilterChange" />
      </template>

      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID Pedido</vs-th>
        <vs-th key="amount_total" sort-key="amount_total">Valor Total</vs-th>
        <vs-th key="user_name">Nome do Usuário</vs-th>
        <vs-th key="user_email">Email do Usuário</vs-th>
        <vs-th key="status" sort-key="status">Status</vs-th>
        <vs-th key="payment_type" sort-key="payment_type">Tipo Pagamento</vs-th>
        <vs-th key="created_at" sort-key="created_at">Data</vs-th>
      </template>

      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="10%" key="id">
            <div>{{ tr.id }}</div>
          </vs-td>
          <vs-td width="15%" key="amount_total">
            <span class="font-semibold">{{
              formatCurrency(tr.amount_total)
            }}</span>
          </vs-td>
          <vs-td width="15%" key="user_name">
            <div>{{ tr.user_name || 'N/A' }}</div>
          </vs-td>
          <vs-td width="20%" key="user_email">
            <div>{{ tr.user_email || 'N/A' }}</div>
          </vs-td>
          <vs-td width="15%" key="status">
            <vs-chip
              :color="getStatusColor(tr.status)"
              class="text-base text-center"
            >
              {{ getStatusLabel(tr.status) }}
            </vs-chip>
          </vs-td>
          <vs-td width="20%" key="payment_type">
            <div>{{ getPaymentTypeLabel(tr.payment_type) }}</div>
          </vs-td>
          <vs-td width="20%" key="created_at">
            <div>{{ $utils.format.date(tr.created_at) }}</div>
          </vs-td>
          <vs-td width="10%">
            <feather-icon
              icon="EyeIcon"
              class="h-5 w-5 mb-1 mr-1 stroke-current text-primary cursor-pointer"
              v-tooltip.top="{
                content: 'Detalhamento',
                delay: { show: 100, hide: 100 }
              }"
              @click="viewDetails(tr)"
            />
          </vs-td>
        </vs-tr>
      </template>
    </Grid>

    <!-- Popup de Detalhamento -->
    <vs-popup
      :title="`Detalhes do Pedido${orderDetails ? ' #' + orderDetails.id : ''}`"
      :active.sync="showDetails"
      class="order-details-popup"
    >
      <div v-if="orderDetails" class="order-details">
        <!-- Informações do Cliente e Pedido -->
        <div class="mb-6 grid grid-cols-2 gap-6">
          <!-- Informações do Cliente -->
          <div v-if="orderDetails.user">
            <h5 class="vs-popup--title mb-1 text-base font-semibold">
              Cliente
            </h5>
            <div class="flex flex-col space-y-2">
              <div>
                <span class="text-gray-600 text-sm">Nome:</span>
                <span class="ml-2 font-medium">{{
                  orderDetails.user.name || 'N/A'
                }}</span>
              </div>
              <div>
                <span class="text-gray-600 text-sm">Email:</span>
                <span class="ml-2 font-medium">{{
                  orderDetails.user.email || 'N/A'
                }}</span>
              </div>
            </div>
          </div>

          <!-- Informações do Pedido -->
          <div>
            <h5 class="vs-popup--title mb-1 text-base font-semibold">Pedido</h5>
            <div class="flex flex-col space-y-2">
              <div>
                <span class="text-gray-600 text-sm">Data:</span>
                <span class="ml-2 font-medium">{{
                  $utils.format.date(orderDetails.created_at)
                }}</span>
              </div>
              <div>
                <span class="text-gray-600 text-sm">Valor Total:</span>
                <span class="ml-2 font-semibold text-lg text-primary">{{
                  formatCurrency(orderDetails.amount_total)
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Itens do Pedido -->
        <div>
          <h5 class="vs-popup--title mb-1 text-base font-semibold">
            Itens do Pedido
          </h5>
          <div v-if="orderDetails.items && orderDetails.items.length > 0">
            <table class="w-full">
              <thead>
                <tr class="border-b">
                  <th
                    class="text-left py-1 px-2 text-sm font-semibold text-gray-700"
                  >
                    Produto
                  </th>
                  <th
                    class="text-center py-1 px-2 text-sm font-semibold text-gray-700"
                  >
                    Qtd
                  </th>
                  <th
                    class="text-right py-1 px-2 text-sm font-semibold text-gray-700"
                  >
                    Valor Unit.
                  </th>
                  <th
                    class="text-right py-1 px-2 text-sm font-semibold text-gray-700"
                  >
                    Subtotal
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in orderDetails.items"
                  :key="index"
                  class="border-b"
                >
                  <td class="py-1 px-2">
                    {{ item.product ? item.product.name : 'N/A' }}
                  </td>
                  <td class="py-1 px-2 text-center">{{ item.quantity }}</td>
                  <td class="py-1 px-2 text-right">
                    {{ formatCurrency(item.price) }}
                  </td>
                  <td class="py-1 px-2 text-right font-semibold">
                    {{ formatCurrency(item.amount_total) }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3" class="py-2 px-2 text-right font-semibold">
                    Total:
                  </td>
                  <td
                    class="py-2 px-2 text-right font-bold text-primary text-base"
                  >
                    {{ formatCurrency(orderDetails.amount_total) }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div v-else class="text-center py-4 text-gray-500">
            Nenhum item encontrado
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import FinancialPeriodFilter from '@/components/filters/FinancialPeriodFilter.vue'
import PaymentOrderService from '@/services/api/PaymentOrderService'
import OrderService from '@/services/api/OrderService'
import { currencyFormatter } from '@/util/Util'

export default {
  components: {
    Grid,
    FinancialPeriodFilter
  },
  data() {
    return {
      service: null,
      orderService: null,
      filters: {
        start_date: null,
        end_date: null
      },
      showDetails: false,
      orderDetails: null
    }
  },
  methods: {
    formatCurrency(value) {
      return currencyFormatter(value)
    },
    getStatusColor(status) {
      const statusMap = {
        PE: 'warning', // Pendente
        PR: 'primary', // Em processamento
        RE: 'danger', // Recusado
        PA: 'success', // Pago
        CA: 'dark' // Cancelado
      }
      return statusMap[status] || 'primary'
    },
    getStatusLabel(status) {
      const statusMap = {
        PE: 'Pendente',
        PR: 'Em processamento',
        RE: 'Recusado',
        PA: 'Pago',
        CA: 'Cancelado'
      }
      return statusMap[status] || status
    },
    getPaymentTypeLabel(paymentType) {
      const typeMap = {
        money: 'Dinheiro',
        credit_card: 'Cartão de crédito',
        debit_card: 'Cartão de débito',
        pix: 'PIX',
        ticket: 'Boleto Bancário',
        ted: 'TED'
      }
      return typeMap[paymentType] || paymentType
    },
    handleFilterChange(filters) {
      this.filters = filters
      this.updateFilters()
    },
    updateFilters() {
      const customFilters = {}

      if (this.filters.start_date) {
        customFilters.start_date = this.filters.start_date
      }

      if (this.filters.end_date) {
        customFilters.end_date = this.filters.end_date
      }

      // Limpar todos os custom_filters primeiro
      this.$refs.grid.custom_filters = []

      // Preencher apenas os filtros que têm valores
      if (Object.keys(customFilters).length > 0) {
        this.$refs.grid.fillCustomFilters(
          Object.keys(customFilters).map(key => ({
            key,
            value: customFilters[key]
          }))
        )
      }

      this.$refs.grid.fetchGridData(true)
    },
    viewDetails(row) {
      this.$vs.loading()
      this.orderService.read(row.id).then(
        response => {
          this.$vs.loading.close()
          this.orderDetails = response
          this.showDetails = true
        },
        error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Erro',
            text: 'Não foi possível carregar os detalhes do pedido.',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }
      )
    }
  },
  beforeMount() {
    this.service = PaymentOrderService.build(this.$vs)
    this.orderService = OrderService.build(this.$vs)
  }
}
</script>

<style scoped>
.vs-select {
  min-width: 200px;
}
</style>
